import { render, staticRenderFns } from "./couponControl.vue?vue&type=template&id=5103937a&scoped=true"
import script from "./couponControl.vue?vue&type=script&lang=js"
export * from "./couponControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103937a",
  null
  
)

export default component.exports